var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXmlIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 32.609,
    viewBox: "0 0 31 32.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40776",
    "data-name": "Group 40776",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40579",
    "data-name": "Group 40579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_48183",
    "data-name": "Path 48183",
    transform: "translate(3.913)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.47824859619141 31.85867691040039 L 2.608689546585083 31.85867691040039 C 1.583799481391907 31.85867691040039 0.7499994039535522 31.02486610412598 0.7499994039535522 29.99997711181641 L 0.7499994039535522 2.608696460723877 C 0.7499994039535522 1.58380651473999 1.583799481391907 0.749996542930603 2.608689546585083 0.749996542930603 L 16.94750595092773 0.749996542930603 L 25.33693885803223 8.172209739685059 L 25.33693885803223 29.99997711181641 C 25.33693885803223 31.02486610412598 24.50313949584961 31.85867691040039 23.47824859619141 31.85867691040039 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.60869026184082 1.499996185302734 C 1.997360229492188 1.499996185302734 1.5 1.997356414794922 1.5 2.608695983886719 L 1.5 29.99997711181641 C 1.5 30.6113166809082 1.997360229492188 31.10867691040039 2.60869026184082 31.10867691040039 L 23.47824859619141 31.10867691040039 C 24.08957862854004 31.10867691040039 24.58693885803223 30.6113166809082 24.58693885803223 29.99997711181641 L 24.58693885803223 8.510072708129883 L 16.66336059570312 1.499996185302734 L 2.60869026184082 1.499996185302734 M 2.60869026184082 -3.814697265625e-06 L 17.23164939880371 -3.814697265625e-06 L 26.08693885803223 7.834365844726562 L 26.08693885803223 29.99997711181641 C 26.08693885803223 31.44071578979492 24.91898918151855 32.60867691040039 23.47824859619141 32.60867691040039 L 2.60869026184082 32.60867691040039 C 1.167949676513672 32.60867691040039 0 31.44071578979492 0 29.99997711181641 L 0 2.608695983886719 C 0 1.167945861816406 1.167949676513672 -3.814697265625e-06 2.60869026184082 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#9facc2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10859",
    "data-name": "Rectangle 10859",
    transform: "translate(0 11.439)",
    fill: "#ada759",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.739,
    height: 13.584,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 26.739,
    height: 14.584,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "XML",
    transform: "translate(2.86 21.724)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "XML")), /*#__PURE__*/React.createElement("g", {
    id: "Path_48182",
    "data-name": "Path 48182",
    transform: "translate(20.452 -0.64)",
    fill: "#9facc2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.747342109680176 9.217700004577637 L 2.854637622833252 9.217700004577637 C 1.55628764629364 9.217700004577637 0.4999976456165314 8.161410331726074 0.4999976456165314 6.863060474395752 L 0.4999976456165314 1.709300518035889 C 1.367619395256042 2.438007116317749 2.810536861419678 3.660751104354858 4.263637542724609 4.939940452575684 C 7.119976043701172 7.454427242279053 8.27886962890625 8.653010368347168 8.747342109680176 9.217700004577637 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.60467529296875 8.717700004577637 C 6.915853023529053 8.017204284667969 5.754406452178955 6.914689540863037 3.797327756881714 5.195720195770264 C 2.788041353225708 4.309224605560303 1.791759014129639 3.456317186355591 0.9999976754188538 2.785326957702637 L 0.9999976754188538 6.863060474395752 C 0.9999976754188538 7.8857102394104 1.831987619400024 8.717700004577637 2.854637622833252 8.717700004577637 L 7.60467529296875 8.717700004577637 M 9.392578125 9.717700004577637 L 2.854637622833252 9.717700004577637 C 1.278067708015442 9.717700004577637 -2.344207814530819e-06 8.439640045166016 -2.344207814530819e-06 6.863060474395752 L -2.344207814530819e-06 0.6401402950286865 C -2.344207814530819e-06 0.6401402950286865 10.96915721893311 9.717700004577637 9.392578125 9.717700004577637 Z",
    stroke: "none",
    fill: "#9facc2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlIcon);
export default __webpack_public_path__ + "static/media/xml-icon.0b764e1a020af08bf7556d90c04223ea.svg";
export { ForwardRef as ReactComponent };